import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { retrieveSchool, schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import { useAppDispatch } from "../../../app/hooks";
import { LoadState } from "../../../redux/common";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { useEffect } from "react";

interface SchoolPageTitleProps {
    schoolId?: string;
}

const SchoolPageTitle = ({ schoolId }: SchoolPageTitleProps) => {
    const user = useSelector(selectUser);
    const school = useSelector(selectSchool);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (school.selected && school.selected.id != schoolId) {
            dispatch(schoolSlice.actions.clean());
        }
        if (school.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveSchool({ schoolId: schoolId }));
        }
    }, [schoolId, school, user]);

    return school.selected?.name ?
        <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            {school.selected.name}
        </Typography>
        : <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            Escola
        </Typography>;
};

export default SchoolPageTitle;